// extracted by mini-css-extract-plugin
module.exports = {"loader":"_15-vq","load6":"_1DbIU","medium":"_3GtKm","mini":"_6R5MY"};